const getCreatedByName = (createdByUser = "") =>
  String(createdByUser).split("@")[0].trim().toLowerCase();

const getDocumentYear = (quotation = {}) => {
  const dateValue = quotation.documentDate || quotation.createdAt;
  const date = dateValue ? new Date(dateValue) : null;
  const year = date && !Number.isNaN(date.getTime()) ? date.getFullYear() : "";
  return String(year || "");
};

const getRunNumberVariants = (runNumber = "") => {
  const raw = String(runNumber || "").trim();
  const digitsOnly = raw.replace(/\D/g, "");

  return Array.from(
    new Set([
      raw,
      digitsOnly,
      digitsOnly ? digitsOnly.padStart(3, "0") : "",
    ].filter(Boolean))
  );
};

const getCompanyPrefixes = (quotation = {}) => {
  const envPrefix = String(process.env.REACT_APP_COMPANY_PREFIX || "").trim();
  if (envPrefix) {
    return [envPrefix];
  }

  const derivedPrefix = quotation.company?.toUpperCase() === "NEON" ? "NW" : "";
  return Array.from(new Set([derivedPrefix, "NW", "OPTX"].filter(Boolean)));
};

const getDocumentCodeVariants = (quotation = {}) => {
  const prefixes = getCompanyPrefixes(quotation);
  const type = String(quotation.type || "M").trim().toUpperCase();
  const year = getDocumentYear(quotation);
  const runNumbers = getRunNumberVariants(quotation.runNumber);

  if (!year || runNumbers.length === 0) {
    return [];
  }

  return Array.from(
    new Set(
      runNumbers.flatMap((runNumber) => [
        ...prefixes.flatMap((prefix) => [
          `${prefix}-QT(${type})-${year}-${runNumber}`,
          `${prefix} QT ${type} ${year} ${runNumber}`,
        ]),
        `QT(${type})-${year}-${runNumber}`,
        `QT ${type} ${year} ${runNumber}`,
      ])
    )
  );
};

const tokenizeSearch = (value = "") =>
  String(value)
    .toLowerCase()
    .split(/[^a-z0-9]+/i)
    .map((token) => token.trim())
    .filter(Boolean);

const buildSearchCandidates = (quotation = {}) =>
  [
    quotation.title,
    quotation.client,
    quotation.clientId?.customerName,
    quotation.runNumber,
    quotation.period,
    quotation.quotationNumber,
    quotation.quotationNo,
    quotation.documentNumber,
    quotation.documentNo,
    quotation.projectName,
    getCreatedByName(quotation.createdByUser),
    ...getDocumentCodeVariants(quotation),
  ]
    .map((value) => String(value || "").toLowerCase())
    .filter(Boolean);

export const quotationMatchesSearch = (quotation = {}, searchTerm = "") => {
  const tokens = tokenizeSearch(searchTerm);

  if (tokens.length === 0) {
    return true;
  }

  const candidates = buildSearchCandidates(quotation);
  return tokens.every((token) =>
    candidates.some((candidate) => candidate.includes(token))
  );
};
